module.exports = __webpack_public_path__ + "img/card_up_icons_15.5dea5380.png";